import { render } from "./ModalResetPassword.vue?vue&type=template&id=b5af0e42&scoped=true"
import script from "./ModalResetPassword.vue?vue&type=script&lang=js"
export * from "./ModalResetPassword.vue?vue&type=script&lang=js"

import "./ModalResetPassword.vue?vue&type=style&index=0&id=b5af0e42&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5af0e42"]])

export default __exports__